import { Headset, X } from "lucide-react";
import { useWorkspace } from "../../store/WorkspaceContext";
import { api } from "../../lib/api";

// Notice pushed by Xpattern support from Fleet → Remote fix (stays until the shop dismisses it).
export const OwnerNotice = () => {
  const { state, dispatch } = useWorkspace();
  const n = state.ownerNotice;
  if (!n?.id) return null;
  const dismiss = () => {
    dispatch({ type: "SET", patch: { ownerNotice: null } });
    api.relayNoticeAck(state.connection?.shopCode, n.id).catch(() => {});
  };
  return (
    <div className="flex items-center gap-3 border-b border-[#4c9ffe]/50 bg-[#4c9ffe]/15 px-3 py-2 text-[12.5px] text-[#cfe3ff]" data-testid="owner-notice">
      <Headset className="h-4 w-4 flex-shrink-0 text-[#8fc1ff]" />
      <span className="min-w-0"><b className="text-[#e8f1ff]">Message from Xpattern support:</b> <span data-testid="owner-notice-text">{n.message}</span></span>
      <button onClick={dismiss} data-testid="owner-notice-dismiss" className="ml-auto flex flex-shrink-0 items-center gap-1 rounded-md border border-[#4c9ffe]/60 bg-[#4c9ffe]/20 px-2.5 py-1 font-semibold text-[#e8f1ff] hover:bg-[#4c9ffe]/35">
        <X className="h-3.5 w-3.5" /> Got it
      </button>
    </div>
  );
};
